(function () {
  const HOST_SELECTOR = '.widerruf-form-block';
  const BRANDING_SELECTOR = '.widerruf-form-branding';

  function getShadowRoot(host) {
    if (host.shadowRoot) return host.shadowRoot;

    for (const child of host.querySelectorAll('*')) {
      if (child.shadowRoot) return child.shadowRoot;
    }

    return null;
  }

  function hideBranding() {
    const host = document.querySelector(HOST_SELECTOR);
    if (!host) return false;

    const root = getShadowRoot(host);
    if (!root) return false;

    const branding = root.querySelector(BRANDING_SELECTOR);
    if (!branding) return false;

    branding.style.setProperty('display', 'none', 'important');
    return true;
  }

  function initWhenReady() {
    if (hideBranding()) return;

    const observer = new MutationObserver(() => {
      if (hideBranding()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();